import { render } from "./Button.vue?vue&type=template&id=ddf0cc66&scoped=true"
import script from "./Button.vue?vue&type=script&lang=js"
export * from "./Button.vue?vue&type=script&lang=js"

import "./Button.vue?vue&type=style&index=0&id=ddf0cc66&lang=stylus&scoped=true"
script.render = render
script.__scopeId = "data-v-ddf0cc66"

export default script